// @ts-nocheck
import _ from "lodash";
import Loader from "core/loader/index";
import Cache from "core/cache/index";
import Memory from "core/performance";
import Helper from "helper/index";
import Config from "config";
import FloatMessageBox from "core/messageBoxController/index";
import LoadingSnackbarManager from "component/atoms/loadingSnackbar/loadingSnackbarManager";

function isLoadComplete(loadedFiles, totalFiles) {
  if (loadedFiles === totalFiles) {
    //LoadingSnackbarManager.complete("Complete", 3000);
    return true;
  }
  return false;
}

/**
 * @description 입력받은 DICOM File handle을 이용해 DICOM 데이터를 파싱하고 Provider에 전달
 * @todo 초기화 메세지 전달 코드 및 에러 핸들러는 의존성 주입 코드로 실행되도록 수정 필요
 * @function BindDICOMSource
 * @param {Array<File>} files
 */
async function DICOMFileProvider(files) {
  const totalFiles = files.length;
  if (totalFiles === 0) {
    return;
  }
  /**
   * 0. Check memory
   * @ref @site : https://stackoverflow.com/questions/23506064/how-do-you-detect-memory-limits-in-javascript
   */
  const hasFreeMemory = Memory.hasFreeMemoryCapacity(30000000 /**30mb */);

  if (hasFreeMemory === false) {
    FloatMessageBox({
      title: "Warning",
      message:
        "The data cannot be loaded.\r\n The memory usage has reached the limit.",
    });
    return;
  }

  // loadingSnackbarManager disable
  LoadingSnackbarManager.loading("Loading", -1);
  let loadedFiles = 0;
  _.forEach(files, (file) => {
    // 확장자 비교를 위해 소문자로 통알하여 비교
    if (Helper.File.getFileExtension(file.name).toLowerCase() !== "dcm") {
      loadedFiles += 1;
      if (isLoadComplete(loadedFiles, totalFiles)) {
        LoadingSnackbarManager.complete("Complete", 3000);
        Config.rootStore.seriesListStore.updateThumbnails();
      }
      return;
    }

    ///
    /// 1. File handle 배열을 이용해 순차적으로 DICOM 파일을 읽고 파싱
    ///
    const reader = new FileReader();
    const fileHandle = file;
    //reader.onload = () => {
    reader.onload = () => {
      let arrayBuffer = reader.result;
      try {
        ///
        /// 2. 읽어들인 파일 내용을 DICOM Loader에 전달하여 DICOM 정보 파싱
        ///

        /// Todo : 아래 코드는 의존성 주입으로 실행되도록 수정 필요
        let dicomLoader = new Loader.LoaderDicom();
        dicomLoader
          .parseFile(fileHandle.name, arrayBuffer)
          .then(function (data) {
            ///
            /// 3. 파싱한 DICOM 정보를 Provider에 전달
            ///
            let metadataCache = new Cache.Metadata();
            const seriesInstanceUID = data.seriesInstanceUID;
            const modality = data.modality;

            if (
              !Helper.Validator.isString(seriesInstanceUID) ||
              !Helper.Validator.isString(modality)
            ) {
              console.error(
                "DICOM Data Type is not correct : seriesInstanceUID or modality"
              );
              return;
            }
            metadataCache.add(seriesInstanceUID, modality, data);
          })
          .catch(function (err) {
            /// Todo : 아래 코드는 의존성 주입으로 실행되도록 수정 필요
            console.error(err);
          })
          .finally(() => {
            loadedFiles += 1;
            if (isLoadComplete(loadedFiles, totalFiles)) {
              LoadingSnackbarManager.complete("Complete", 3000);
              Config.rootStore.seriesListStore.updateThumbnails();
            }
          });
      } catch (ex) {
        /// Todo : 아래 코드는 의존성 주입으로 실행되도록 수정 필요
        const parameters = {
          title: "Warning",
          message: "This data is not supported format",
          buttonType: "OK",
          hasCloseButton: false,
          hasTodayOffButton: false,
        };
        FloatMessageBox(parameters);
        console.log("file reading was failed");
        loadedFiles += 1;
        if (isLoadComplete(loadedFiles, totalFiles)) {
          LoadingSnackbarManager.complete("Complete", 3000);
          Config.rootStore.seriesListStore.updateThumbnails();
        }
      }
    };
    /// Todo :  아래 코드는 의존성 주입으로 실행되도록 수정 필요
    reader.onabort = () => console.log("file reading was aborted");
    reader.onerror = () => console.log("file reading has failed");
    reader.readAsArrayBuffer(file);
  });
}

export default DICOMFileProvider;
